import type {
  ReactElement,
  ReactNode,
} from 'react';

import styled from 'styled-components';

import { Dropdown } from '../Dropdown';

import { createDropdownMenu } from '../createDropdownMenu';
import type {
  DropdownMenuItemType,
} from '../createDropdownMenu';

import { IconAction } from './IconAction';
import { DropdownReference } from './DropdownReference';

const StyledTableActions = styled.div({
  display: 'flex',
  alignItems: 'center',
});

const StyledDropdown = styled.div(({
  theme: {
    indents,
  },
}) => ({
  display: 'flex',
  marginLeft: indents.INDENT_2,
}));

export type TableActionsProps = {
  className?: string;
  /**
   * Список действий в формате @n3/react-dropdown-menu
   */
  actions: DropdownMenuItemType[];
  /**
   * Выключены ли действия
   */
  disabled?: boolean;
};

export function TableActions({
  disabled = false,
  className = '',
  actions,
}: TableActionsProps): ReactElement | null {
  if (actions.length === 0) {
    return null;
  }

  const iconActions = actions.slice(0, 3);
  const dropdownActions = actions.slice(3, actions.length);

  return (
    <StyledTableActions
      className={className}
    >
      {
        iconActions.map((action, index) => (
          <IconAction
            action={action}
            disabled={disabled}
            key={index}
          />
        ))
      }

      {
        dropdownActions.length > 0 && (
          <StyledDropdown>
            <Dropdown
              {...createDropdownMenu(dropdownActions)}
              placement="bottom-end"
            >
              {({
                isDropdownOpen,
                onClick,
                ref,
              }): ReactNode => (
                <DropdownReference
                  isDropdownOpen={isDropdownOpen}
                  disabled={disabled}
                  onClick={onClick}
                  ref={ref}
                />
              )}
            </Dropdown>
          </StyledDropdown>
        )
      }
    </StyledTableActions>
  );
}
